export default function ChannelFinanceIcon({ className }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={`${className || ''} text-current`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="1.5" opacity="0.35" />

      <circle cx="32" cy="32" r="12" fill="white" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="32" cy="32" r="3.2" fill="currentColor" />

      <path d="M27 26H37" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M27 30H37" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M32 26V36" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M29 36C29 38 30.5 39 32 39C33.5 39 35 38 35 36" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" fill="none" />

      <circle cx="32" cy="12" r="5" fill="white" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="16" cy="44" r="5" fill="white" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="48" cy="44" r="5" fill="white" stroke="currentColor" strokeWidth="1.8" />

      <path d="M32 17L32 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M18 42L24 38" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M46 42L40 38" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M32 35L32 40" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />

      <path d="M32 22L18 44" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M32 22L46 44" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M32 36L18 46" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M32 36L46 46" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
